"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const bundles = [{
  id: "bundle-1",
  name: "Cement & Concrete Supplies",
  description: "Premium grade Portland cement and reinforced concrete additives for large-scale structural foundations.",
  price: "AUD 100 – 850",
  badge: "Bulk Only",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/cement_wholesale.png"
}, {
  id: "bundle-2",
  name: "Structural Steel & Metal",
  description: "Industrial strength rebar, steel beams, and metal mesh compliant with Australian construction standards.",
  price: "AUD 500 – 2,000",
  badge: "AU Standards",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/steel_wholesale.png"
}, {
  id: "bundle-3",
  name: "Plumbing & Piping Systems",
  description: "Comprehensive wholesale inventory of PVC, copper piping, and industrial hydraulic hardware solutions.",
  price: "AUD 150 – 1,200",
  badge: "Trade Only",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1597043/img/plumbing_wholesale.png"
}];
export default function EssentialFamilyBundles() {
  return <section data-section-id="152714" id="wholesale-inventory" className="bg-background py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="font-serif text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl uppercase">
            Wholesale Inventory
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-sans">
            Direct access to high-volume building materials and hardware. Reliable supply chains for Australia's commercial construction and trade sectors.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-12">
          {bundles.map((bundle, i) => <Card key={bundle.id} data-index={i} className="group relative flex h-full flex-col overflow-hidden border-border bg-card shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md hover:bg-accent hover:border-chart-1 rounded-md">
              <div className="relative aspect-square overflow-hidden bg-muted/10 p-6">
                <Badge variant="secondary" className="absolute left-4 top-4 z-10 bg-primary text-primary-foreground font-mono text-xs uppercase tracking-wider">
                  {bundle.badge}
                </Badge>
                <img src={bundle.image} alt={bundle.name} className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105" />
              </div>

              <CardHeader className="flex-none pb-2 text-center">
                <CardTitle className="font-serif text-xl font-bold text-foreground tracking-tight">
                  {bundle.name}
                </CardTitle>
                <CardDescription className="mt-2 text-sm text-muted-foreground font-sans">
                  {bundle.description}
                </CardDescription>
              </CardHeader>

              <CardContent className="flex-grow text-center pb-4">
                <span className="text-lg font-mono font-medium text-chart-1">
                  {bundle.price}
                </span>
              </CardContent>

              <CardFooter className="flex-none pt-0 pb-8 px-8">
                <Button variant="outline" className="w-full rounded-sm border-border bg-background text-foreground hover:bg-primary hover:text-primary-foreground transition-colors duration-300 font-sans uppercase text-xs font-bold tracking-widest">
                  <Plus className="mr-2 h-4 w-4" />
                  Request Quote
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}